import { Button, useModal } from "@newsela/angelou";
import React from "react";

import { IPageViewModelStandard } from "@/types/models/ContentPageViewModel.interface";
import ContentDisplayDetailsRow from "@/view/ContentDisplay/ContentDisplayDetails/ContentDisplayDetailsRow";
import { standardsCss } from "./GeniusStandardsRow.style";
import GeniusStandardsModal from "./GeniusStandardsModal";

interface GeniusStandardsRowProps {
  standards: IPageViewModelStandard[];
}

const GeniusStandardsRow: React.FC<GeniusStandardsRowProps> = ({
  standards,
}) => {
  const [modalProps, setActive, triggerRef] = useModal(false);

  if (!standards || standards.length === 0) return null;

  const standardsLabel = `Standards (${standards.length})`;

  const getStandardsValue = () => {
    const standardNames = standards.map((standard) => standard.name);
    const isTruncatedList = standardNames.length > 3;
    const standardsText =
      standardNames.length > 3
        ? standardNames.slice(0, 3).join(", ") + "..."
        : standardNames.join(", ");
    return (
      <>
        <span css={standardsCss}>{standardsText}</span>
        <Button
          flavor={Button.flavors.tertiary}
          size={Button.sizes.md}
          onClick={() => setActive(true)}
          ref={triggerRef}
        >
          {isTruncatedList ? "View all" : "View details"}
        </Button>
      </>
    );
  };

  const standardsRowData = [
    { label: standardsLabel, value: getStandardsValue() },
  ];

  return (
    <>
      <ContentDisplayDetailsRow row={standardsRowData} />
      <GeniusStandardsModal
        standards={standards}
        standardsLabel={standardsLabel}
        setActive={setActive}
        modalProps={modalProps}
      />
    </>
  );
};

export default GeniusStandardsRow;
